var React = require('react/addons');
var cx = require('classnames');
var Fluxxor = require('fluxxor');
var GalleryItem = require('./gallery-item');
var _ = require('underscore');
var ModalMixin = require('ofs/components/layers/ModalMixin');

var Gallery = React.createClass({
  mixins: [
    ModalMixin,
    Fluxxor.StoreWatchMixin("GalleryStore")
  ],

  getStateFromFlux: function() {
    return this.getFlux().store('GalleryStore').getState();
  },

  getPreviousIndex: function() {
    if (this.state.activeImageIndex === 0) {
      return this.state.imageList.length - 1;
    }
    return this.state.activeImageIndex - 1;
  },

  getNextIndex: function() {
    if (this.state.activeImageIndex === this.state.imageList.length -1 ) {
      return 0;
    }
    return this.state.activeImageIndex + 1;
  },

  handlePrevious: function(event) {
    event.preventDefault();
    this.getFlux().actions.gallery.changeActive(this.getPreviousIndex());
  },

  handleNext: function(event) {
    event.preventDefault();
    this.getFlux().actions.gallery.changeActive(this.getNextIndex());
  },

  handleImageClick: function() {
    if (this.state.isHeaderVisible) {
      this.getFlux().actions.gallery.hideHeader();
    } else {
      this.getFlux().actions.gallery.showHeader();
    }
  },

  render: function() {
    var galleryItems = this.state.imageList.map(_.bind(function(item, index) {
      var key = item.label + ':' + item.url;
      return <GalleryItem key={key} url={item.url} width={item.width} height={item.height} active={index==this.state.activeImageIndex} />;
    }, this));

    var activeItem = this.state.imageList[this.state.activeImageIndex];
    var nextItem = this.state.imageList[this.getNextIndex()];
    var previousItem = this.state.imageList[this.getPreviousIndex()];

    var overlayClasses = cx({
      'react-modal-overlay': true,
      'react-modal-loaded': this.state.loaded
    });

    var classes = cx({
      'react-gallery-toolbar': true,
      'hidden': !this.state.isHeaderVisible
    });

    return (
      <div className={overlayClasses} onClick={this.handleClose}>
        <div className="react-gallery" onClick={this.killClick} style={this.state.style}>
          <header className={classes}>
             <h1>{activeItem.label}</h1>
            <a href="javascript:;" onClick={this.handleClose} className="react-modal-close">Close</a>
          </header>
          <a href="javascript:;" className="react-gallery-previous" onClick={this.handlePrevious}>
            <span className="icon icon-left-arrow" />
            {previousItem.label !== activeItem.label ? <span className="label">{nextItem.label}</span> : null}
          </a>
          <div className="react-gallery-items" onClick={this.handleImageClick}>
             {galleryItems}
          </div>
          <a href="javascript:;" className="react-gallery-next" onClick={this.handleNext}>
            {nextItem.label !== activeItem.label ? <span className="label">{nextItem.label}</span> : null}
            <span className="icon icon-right-arrow" />
          </a>
        </div>
      </div>
    );
  }

});

module.exports = Gallery;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/components/gallery/gallery.jsx
 **/